<!-- Spinner -->

<!-- Content -->
@if ((appSharedFacade.metadata$ | async); as metadata) {
  <div class="mdsf-container js-modal-content-container"
    >
    <div class="mdsf-elearning-container align-items-center scrollable m-0 p-0 w-100 flex-grow-1">
      <medsurf-carousel></medsurf-carousel>
      @if ((nodeSharedFacade.elearnings$ | async) | sortBy_shared:'asc':'position'; as elearnings) {
        <div class="mdsf-elearnings"
          >
          @if (elearnings !== undefined) {
            <div></div>
          } @else {
            <div class="d-flex justify-content-center m-2">
              <div class="spinner-border"></div>
            </div>
          }
          @for (node of elearnings; track node) {
            @if (!node.hidden) {
              <medsurf-listnav
                [node]="node"
                [locked]="(appSharedFacade.canReadNode$(node?.id) | async) === false"
                [showSubjects]="metadata.carouselShowSubjects">
              </medsurf-listnav>
            }
          }
        </div>
      }
    </div>
    <medsurf-footer class="d-none d-md-inline"
      [links]="footerLinks"
      align="center">
    </medsurf-footer>
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
